import React from 'react'
import logo from '../../assets/img/logo.png'
import rightArrow from '../../assets/img/right-arrow.png'
import {
  AddressLine, Boxes, HOME_ID_GAPS, ID_CARD_GAPS, L, Mark, Star, Tel, blank,
} from './docParts'
import {
  admissionBeYear, classLabel, dateParts, digits, islamicClassLabel, nameParts,
} from './printFormat'

// ใบสมัครนักเรียนใหม่ — ยกโครงมาจาก PrintMatthayomComponent / PrintPrathomComponent
// ของระบบเดิม สองไฟล์นั้นเป็นเอกสารคนละแบบจริงๆ (ไม่ใช่แค่เปลี่ยนคำ) จึงแยกเป็น
// สองฟังก์ชันในไฟล์เดียว แต่ใช้ชิ้นส่วนร่วมกันหมด

const PROGRAMS_JUNIOR = [
  ['simp', '1. SIMP (Science Intelligent Mathematics Program)', 'ความเป็นเลิศด้าน วิทยาศาสตร์ คณิตศาสตร์'],
  ['aip',  '2. AIP (Arab Islamic Program) รายวิชาศาสนาเน้นภาษาอาหรับ'],
  ['aep',  '3. AEP (Art English Program) เน้นภาษาอังกฤษ'],
  ['asp',  '4. ASP (Art Sports Program) เน้นกีฬา (ฟุตบอลและความถนัดทางกีฬา)'],
  ['ap',   '5. AP (Art Program) โปรแกรมทั่วไป (เน้นสังคม ภาษาอังกฤษ)'],
  ['stp',  '6. STP (Smart Tahfiz Program) ความเป็นเลิศด้านการท่องอัลกุรอาน'],
]

const PROGRAMS_HIGH = [
  ['simp', '1. SIMP (Science Intelligent Mathematics Program)', 'ความเป็นเลิศด้าน วิทยาศาสตร์ คณิตศาสตร์'],
  // บรรทัดย่อย "คณิตศาสตร์" ซ้ำกับท้ายบรรทัดบน — เป็นแบบนี้ในเอกสารเดิม คงไว้ให้ตรงกัน
  ['smp',  '2. SMP (Science Mathematics Program) วิทยาศาสตร์ คณิตศาสตร์', 'คณิตศาสตร์'],
  ['aep',  '3. AEP (Art English Program) เน้นภาษาอังกฤษ'],
  ['asp',  '4. ASP (Art Sports Program) เน้นกีฬา (ฟุตบอลและความถนัดทางกีฬา)'],
  ['ap',   '5. AP (Art Program) โปรแกรมทั่วไป (เน้นสังคม ภาษาอังกฤษ)'],
]

const ProgramList = ({ list, row, study }) => (
  <>
    {list.map(([code, label, sub]) => (
      <React.Fragment key={code}>
        <Mark on={row.regis_academicProgram === code && row.regis_academicStudy === study} className="me-1" />
        {label}
        <br />
        {sub && <>{blank(1)}{sub}<br /></>}
      </React.Fragment>
    ))}
  </>
)

// กล่องหลักฐานการสมัคร — ช่องติ๊กเปล่าให้เจ้าหน้าที่กรอกตอนรับเอกสาร
const EvidenceBox = ({ withShahadah }) => (
  <table className="table-bordered">
    <tbody>
      <tr>
        <td className="ps-2 pe-2 text-center">
          <span className="fw-bold">สำเนาบัตรประจำตัวประชาชน</span>
          <br />
          <Mark className="me-1" />นักเรียน
          <Mark className="ms-1 me-1" />บิดา
          <Mark className="ms-1 me-1" />มารดา
          <Mark className="ms-1 me-1" />อื่นๆ..........................
          <br />
          <span className="fw-bold">สำเนาทะเบียนบ้าน</span>
          <br />
          <Mark className="me-1" />นักเรียน
          <Mark className="ms-1 me-1" />บิดา
          <Mark className="ms-1 me-1" />มารดา
          <Mark className="ms-1 me-1" />อื่นๆ..........................
          <br />
          <div className="text-left ms-5">
            <Mark className="me-1" />สำเนาระเบียนแสดงผลการเรียน (ปพ. 1)
            <br />
            <Mark className="me-1" />สำเนาใบรับรองผลการเรียน (ปพ. 7)
            <br />
            {withShahadah && (
              <>
                <Mark className="me-1" />สำเนาซาฮาดะห์ หรือตัสเดกศาสนา (ถ้ามี)
                <br />
              </>
            )}
            <Mark className="me-1" />รูปถ่ายหน้าตรงขนนาด 1.5 นิ้ว
          </div>
        </td>
      </tr>
    </tbody>
  </table>
)

const SignBox = ({ padClass = 'ps-4 pt-3 pe-4 pb-2' }) => (
  <table className="table-bordered">
    <tbody>
      <tr>
        <td className={`text-center ${padClass}`}>
          ลงชื่อ.............................................
          <br />
          (...................................................................)
          <br />
          ผู้สมัคร
        </td>
      </tr>
      <tr>
        <td className={`text-center ${padClass}`}>
          ลงชื่อ.............................................
          <br />
          (...................................................................)
          <br />
          เจ้าหน้าที่รับสมัคร
        </td>
      </tr>
    </tbody>
  </table>
)

// หัวกระดาษ: ตราโรงเรียน + กล่องชื่อเอกสาร + กล่องแผนก/ช่องติดรูป
const DocHeader = ({ beYear, schoolName, deptLabel, options, selected, regisDate }) => (
  <>
    <tr>
      <td rowSpan={2} className="text-center">
        <img src={logo} width={100} height={100} alt="" />
      </td>
      <td colSpan={2} className="text-center">
        <br />
        <div className="shadow-sm" style={{ border: 'solid 2px', padding: '10px', display: 'inline-block' }}>
          <h4 className="fw-bold text-center">
            ใบสมัครนักเรียนใหม่ ปีการศึกษา {beYear}
            <br />
            {schoolName}
          </h4>
        </div>
      </td>
      <td className="text-center p-2" rowSpan={3}>
        <span
          className="fs-5 shadow-sm fw-bold mb-1"
          style={{ border: 'solid 2px', padding: '5px', display: 'inline-block' }}
        >
          {deptLabel}
        </span>
        <br />
        {options.map(([value, label], i) => (
          <React.Fragment key={value}>
            <Mark on={selected === value} className={i === 0 ? 'me-1' : 'me-1 ms-4'} />
            <span className="fw-bold fs-6">{label}</span>
          </React.Fragment>
        ))}
        <div className="photo-1dot5 text-center fs-5 fw-bold">
          <br />
          <br />
          รูปถ่ายขนาด 1.5 นิ้ว
        </div>
      </td>
    </tr>
    <tr>
      <td colSpan={2} className="text-center">
        <span className="fw-bold fs-5">
          สมัครวันที่<L value={regisDate && regisDate[0]} pad={1} />
          เดือน<L value={regisDate && regisDate[1]} pad={5} />
          พ.ศ<L value={regisDate && regisDate[2]} pad={2} />
        </span>
      </td>
    </tr>
  </>
)

/* ── บิดา/มารดา (กล่องมีเส้นขอบ ใช้เหมือนกันทั้งสองใบ) ───────────────────── */

const ParentCell = ({ label, name, birthdate, idcard, life }) => {
  const n = nameParts(name)
  const bd = dateParts(birthdate)
  return (
    <td className="text-center p-1" colSpan={2}>
      <div className="text-left ms-3">
        <Star />
        <span className="fw-bold">{label} </span>
        ชื่อ<L value={n.prefixFirst} pad={8} />
        สกุล<L value={n.last} pad={7} />
        <br />
        {blank(3)}
        เกิดวันที่<L value={bd && bd[0]} pad={1} />
        เดือน<L value={bd && bd[1]} pad={5} />
        พ.ศ<L value={bd && bd[2]} pad={2} />
      </div>
      <span className="fw-bold">เลขประจำตัวประชาชน</span>
      <br />
      <Boxes chars={digits(idcard, 13)} gaps={ID_CARD_GAPS} />
      <div className="mt-2">
        <Mark on={life === '1'} className="me-1" />
        <span className="fw-bold fs-6">ยังมีชีวิตอยู่</span>
        <Mark on={life === '0'} className="me-1 ms-5" />
        <span className="fw-bold fs-6">เสียชีวิต</span>
      </div>
    </td>
  )
}

const ParentsTable = ({ row }) => (
  <table className="table-bordered">
    <tbody>
      <tr>
        <ParentCell
          label="บิดา" name={row.st_fatherName} birthdate={row.st_fatherBirthdate}
          idcard={row.st_fatherIdCard} life={row.st_fatherLife}
        />
        <ParentCell
          label="มารดา" name={row.st_motherName} birthdate={row.st_motherBirthdate}
          idcard={row.st_motherIdCard} life={row.st_motherLife}
        />
      </tr>
    </tbody>
  </table>
)

// สถานภาพสมรส / จำนวนพี่น้อง / ผู้ปกครอง — เหมือนกันทั้งสองใบ
const FamilyBlock = ({ row }) => (
  <>
    <div className="ps-1 pt-1 pe-1 text-left">
      {blank(6)}
      <Star className="me-2" />
      <span className="fw-bold">สถานภาพสมรสของบิดา มารดา</span>
      <Mark on={row.st_parentStatus === 'togather'} className="ms-5 me-1" />
      <span className="fw-bold fs-6">อยู่ด้วยกัน</span>
      <Mark on={row.st_parentStatus === 'separated'} className="ms-5 me-1" />
      <span className="fw-bold fs-6">แยกกันอยู่</span>
      <Mark on={row.st_parentStatus === 'divorce'} className="ms-5 me-1" />
      <span className="fw-bold fs-6">หย่าร้าง</span>
    </div>
    <div className="text-left">
      {blank(6)}
      <Star className="me-2" />
      <span className="fw-bold">
        จำนวนพี่น้องทั้งหมด<L value={row.st_sibling} pad={4} />คน{blank(2)}
        เป็นบุตรคนที่<L value={row.st_childnumber} pad={4} />{blank(2)}
        จำนวนพี่น้องที่เรียนอยู่<L value={row.st_studyingSibling} pad={4} />คน
      </span>
    </div>
    <div className="text-left">
      {blank(6)}
      <Star className="me-2" />
      <span className="fw-bold">ผู้ปกครองนักเรียน</span>
      <Mark on={row.st_parent === 'dad'} className="ms-5 me-1" />
      <span className="fw-bold fs-6">บิดา</span>
      <Mark on={row.st_parent === 'mom'} className="ms-5 me-1" />
      <span className="fw-bold fs-6">มารดา</span>
      <Mark on={row.st_parent === 'other'} className="ms-5 me-1" />
      <span className="fw-bold fs-6">
        บุคคลอื่น ระบุ<L value={row.st_parentname} pad={7} />
      </span>
    </div>
    <div className="text-left pt-2">
      {blank(11)}
      <Tel />
      <span className="fw-bold">เบอร์โทรศัพท์</span>
      <L
        pad={15}
        value={
          row.st_parent === 'dad' ? row.st_fatherPhone
            : row.st_parent === 'mom' ? row.st_motherPhone
              : row.st_parentPhone
        }
      />
    </div>
  </>
)

/* ── ใบสมัคร: แผนกมัธยมศึกษา ─────────────────────────────────────────────── */

const MatthayomApplication = ({ row, school, beYear }) => {
  const n = nameParts(row.st_name)
  const bd = dateParts(row.st_birthdate)
  const regis = dateParts(row.regis_date)

  return (
    <center>
      <table>
        <tbody>
          <DocHeader
            beYear={beYear} schoolName={school} deptLabel="แผนกมัธยมศึกษา"
            options={[['junior', 'ม.ต้น'], ['high', 'ม.ปลาย']]}
            selected={row.regis_academicStudy} regisDate={regis}
          />
          <tr>
            <td colSpan={3}>
              <span className="fw-bold fs-5">
                -------------------------------------------------------------------------------------------------------------------------
              </span>
              <br />
              <table>
                <tbody>
                  <tr>
                    <td>
                      <Star />
                      <span className="fw-bold">ผู้สมัคร </span>
                      ชื่อ<L value={n.prefixFirst} pad={7} />
                      สกุล<L value={n.last} pad={6} />
                      <br />
                      {blank(4)}
                      เกิดวันที่<L value={bd && bd[0]} pad={1} />
                      เดือน<L value={bd && bd[1]} pad={5} />
                      พ.ศ<L value={bd && bd[2]} pad={2} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <br />
              {blank(1)}เลขประจำตัวประชาชน
            </td>
            <td colSpan={2}>
              <br />
              <Boxes chars={digits(row.st_idcard, 13)} gaps={ID_CARD_GAPS} />
            </td>
            <td className="text-center">
              <span className="fw-bold">เลขประจำตัวนักเรียน</span>
              <br />
              <Boxes chars={digits(row.st_idnumber, 5)} className="box-space" />
            </td>
          </tr>
          <tr>
            <td className="pt-1">{blank(1)}เลขรหัสประจำบ้าน</td>
            <td className="pt-1" colSpan={2}>
              <Boxes chars={digits(row.st_homeID, 11)} gaps={HOME_ID_GAPS} />
            </td>
            <td />
          </tr>
          <tr>
            <td colSpan={4}>
              {blank(1)}
              <AddressLine
                detail={row.st_current} subDistrict={row.st_currentSubDistrict}
                district={row.st_currentDistrict} province={row.st_currentProvince}
              />
              รหัสไปรษณีย์<L value={row.st_zipcode} pad={5} />
            </td>
          </tr>
        </tbody>
      </table>

      <ParentsTable row={row} />
      <FamilyBlock row={row} />

      <div className="text-left ms-4">
        <table>
          <tbody>
            <tr>
              <td>
                <img src={rightArrow} width={30} height={80} alt="" />
              </td>
              <td>
                <Star className="me-2" />
                <span className="fw-bold"><u>ประวัติการศึกษา</u></span>
                <br />
                วิชาสามัญจบชั้นสูงสุด ชั้น<L value={classLabel(row.st_prevAcademicClass)} pad={5} />
                จากโรงเรียน<L value={row.st_prevAcademicSchool} pad={10} />
                อำเภอ<L value={row.st_prevAcademicDistrict} pad={5} />
                จังหวัด<L value={row.st_prevAcademicProvince} pad={5} />
                <br />
                วิชาศาสนาจบชั้นสูงสุด ชั้น<L value={islamicClassLabel(row.st_prevIslamicClass)} pad={5} />
                จากโรงเรียน<L value={row.st_prevIslamicSchool} pad={10} />
                อำเภอ<L value={row.st_prevIslamicDistrict} pad={5} />
                จังหวัด<L value={row.st_prevIslamicProvince} pad={5} />
              </td>
            </tr>
            <tr>
              <td colSpan={2} className="ps-4">
                {blank(1)}
                <Star className="me-2" />
                <span className="fw-bold"><u>โปรแกรมที่สมัครเรียน</u></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <table className="table-bordered">
          <thead>
            <tr>
              <td className="text-center fw-bold ps-3 pe-3" colSpan={2}>การศึกษาวิชาสามัญ</td>
              <td className="text-center fw-bold ps-2 pe-2">การศึกษาวิชาศาสนา</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="ps-2 pe-2">
                <span className="fw-bold">สมัครเรียนระดับมัธยมศึกษาตอนต้น</span>
                <br />
                {row.regis_academicClass && row.regis_academicStudy === 'junior' ? (
                  <>
                    ชั้น <p className="underline"> {classLabel(row.regis_academicClass)} </p>
                    /<p className="underline">  </p>
                  </>
                ) : 'ชั้น ม. ............./..............'}
                <br />
                <ProgramList list={PROGRAMS_JUNIOR} row={row} study="junior" />
              </td>
              <td className="ps-2 pe-2">
                <span className="fw-bold">สมัครเรียนระดับมัธยมศึกษาตอนปลาย</span>
                <br />
                {row.regis_academicClass && row.regis_academicStudy === 'high' ? (
                  <>
                    ชั้น <p className="underline"> {classLabel(row.regis_academicClass)} </p>
                    /<p className="underline">  </p>
                  </>
                ) : 'ชั้น ม. ............./..............'}
                <br />
                <ProgramList list={PROGRAMS_HIGH} row={row} study="high" />
              </td>
              <td className="text-center">
                ผ่านการทดสอบ ได้ชั้น
                <br />
                <br />
                ....................................
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="text-left mt-1 ms-5">
        {blank(1)}
        <i className="fw-bold">
          <u>สำหรับเจ้าหน้าที่: </u>ระบุหลักฐานที่ปรากฏในวันรับสมัครและระบุหอพักนักเรียน
        </i>
      </div>

      <div>
        <table>
          <tbody>
            <tr>
              <td><EvidenceBox withShahadah /></td>
              <td>
                <table className="table-bordered">
                  <tbody>
                    <tr>
                      <td className="fw-bold p-3">
                        <u>หมายเหตุ</u> หลักฐานการสมัคร
                        <br />
                        {blank(3)}รูปถ่าย จำนวน 4 รูป{blank(3)}
                        <br />
                        {blank(3)}สำเนาต่างๆ อย่างละ 1 ชุด{blank(3)}
                        <br />
                        {blank(3)}พร้อมเซ็นสำเนาถูกต้อง{blank(3)}
                      </td>
                    </tr>
                    <tr>
                      <td className="fw-bold p-2">
                        เขตหอพัก<L value={row.dorn_zone} pad={8} />
                        <br />
                        เลขที่หอพัก<L value={row.dorn_number} pad={8} />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td><SignBox /></td>
            </tr>
          </tbody>
        </table>
      </div>
    </center>
  )
}

/* ── ใบสมัคร: แผนกอนุบาล-ประถม ───────────────────────────────────────────── */

const PrathomApplication = ({ row, school, beYear }) => {
  const student = nameParts(row.st_name)
  const guardian = nameParts(row.st_parentname)
  const bd = dateParts(row.st_birthdate)
  const regis = dateParts(row.regis_date)

  return (
    <center>
      <table>
        <tbody>
          <DocHeader
            beYear={beYear} schoolName={school} deptLabel="แผนกอนุบาล-ประถม"
            options={[['anubal', 'อนุบาล'], ['prathom', 'ประถม']]}
            selected={row.regis_academicStudy} regisDate={regis}
          />
          <tr>
            <td colSpan={3}>
              <span className="fw-bold fs-5">
                -------------------------------------------------------------------------------------------------------------------------
              </span>
              <br />
            </td>
          </tr>
          <tr>
            <td />
            <td colSpan={2} />
            <td className="text-center">
              <span className="fw-bold">เลขประจำตัวนักเรียน</span>
              <br />
              <Boxes chars={digits(row.st_idnumber, 5)} className="box-space" />
            </td>
          </tr>
          <tr>
            <td className="pt-1" colSpan={3}>
              <Star />
              <span className="fw-bold">ข้าพเจ้า</span>&nbsp;
              ชื่อ<L value={guardian.prefixFirst} pad={15} />
              สกุล<L value={guardian.last} pad={13} />
            </td>
            <td />
          </tr>
          <tr>
            <td colSpan={4}>
              {blank(1)}
              เกี่ยวข้องกับนักเรียน เป็น
              <Mark on={row.st_parent === 'dad'} className="ms-5 me-1" />
              <span className="fw-bold fs-6">บิดา</span>
              <Mark on={row.st_parent === 'mom'} className="ms-5 me-1" />
              <span className="fw-bold fs-6">มารดา</span>
              <Mark on={row.st_parent === 'other'} className="ms-5 me-1" />
              <span className="fw-bold fs-6">
                บุคคลอื่น ระบุ<L value={row.st_parent === 'other' ? row.st_parentRelation : ''} pad={7} />
              </span>
              <br />
              {blank(1)}
              <AddressLine
                detail={row.st_current} subDistrict={row.st_currentSubDistrict}
                district={row.st_currentDistrict} province={row.st_currentProvince}
              />
              <br />
              {blank(1)}
              รหัสไปรษณีย์<L value={row.st_parentZipcode} pad={16} />
              เบอร์โทรศัพท์<L value={row.st_parentPhone} pad={16} />
              <br />
              <Star />
              <span className="fw-bold">ขอสมัคร</span>&nbsp;
              ชื่อ<L value={student.prefixFirst} pad={14} />
              สกุล<L value={student.last} pad={12} />
              ชั้น<L value={classLabel(row.regis_academicClass)} pad={6} />
              <br />
              {blank(1)}
              วัน เดือน ปี เกิด<L value={bd && bd.join(' ')} pad={5} />
              โรงเรียนเดิม<L value={row.st_prevAcademicSchool} pad={8} />
              อำเภอ<L value={row.st_prevAcademicDistrict} pad={6} />
              จังหวัด<L value={row.st_prevAcademicProvince} pad={6} />
              <div>
                {blank(1)}
                เลขประจำตัวประชาชน
                <span className="ms-3" />
                <Boxes chars={digits(row.st_idcard, 13)} gaps={ID_CARD_GAPS} />
              </div>
              <div className="mt-2 mb-2">
                {blank(1)}
                เลขรหัสประจำบ้าน
                <span className="ms-3" />
                <Boxes chars={digits(row.st_homeID, 11)} gaps={HOME_ID_GAPS} />
              </div>
              {blank(1)}
              <AddressLine
                detail={row.st_current} subDistrict={row.st_currentSubDistrict}
                district={row.st_currentDistrict} province={row.st_currentProvince}
              />
              <br />
              {blank(1)}
              รหัสไปรษณีย์<L value={row.st_zipcode} pad={16} />
            </td>
          </tr>
        </tbody>
      </table>

      <ParentsTable row={row} />
      <FamilyBlock row={row} />

      <br />
      <div className="text-left mt-1 ms-5">
        {blank(1)}
        <i className="fw-bold">
          <u>สำหรับเจ้าหน้าที่: </u>ระบุหลักฐานที่ปรากฏในวันรับสมัคร
        </i>
      </div>

      <div>
        <table>
          <tbody>
            <tr>
              <td>
                <table className="table-bordered">
                  <tbody>
                    <tr>
                      <td className="p-0">
                        <EvidenceBox withShahadah={false} />
                      </td>
                    </tr>
                    <tr>
                      <td className="fw-bold ps-2 pe-2">
                        <u>หมายเหตุ</u> หลักฐานการสมัคร **(รูปถ่าย จำนวน 4 รูป
                        <br />
                        และสำเนาต่างๆ อย่างละ 1 ชุด พร้อมเซ็นสำเนาถูกต้อง)
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td>{blank(16)}</td>
              <td><SignBox padClass="p-4" /></td>
            </tr>
          </tbody>
        </table>
      </div>
    </center>
  )
}

export default function ApplicationDoc({ row, school }) {
  const beYear = admissionBeYear(row.regis_date)
  const isSecondary = ['junior', 'high'].includes(row.regis_academicStudy)
  const Doc = isSecondary ? MatthayomApplication : PrathomApplication
  return (
    <div className="adm-doc adm-doc-application">
      <Doc row={row} school={school} beYear={beYear} />
    </div>
  )
}
